module.exports = __webpack_public_path__ + "static/media/tagMember.687aaca2.svg";